  // Start Mini cart function
  const CART_PAGE_PATH = "/cart";
  const MIN_PRICE_LIMIT = 6;
  let vendorArray = [];
  let checkArray = [];
  
  function handleMiniCart() {
    const productCardMini = document.querySelectorAll(".check-vendor-mini-cart");
    for (let product of productCardMini) {
      const vendorName = product.querySelector(".vendor-name-mini").textContent;
      checkArray.push(vendorName);
    }
    for (let i = 0; i < checkArray.length; i++) {
      if (!vendorArray.includes(checkArray[i])) {
        vendorArray.push(checkArray[i]);
      }
    }
  }
  
  console.log("Vendor Name " + document.querySelector(".vendor-name"));
  function checkForInput() {
    if (document.querySelector(".form-product-container") !== null) {
      const formProductContainer = document.querySelector(
        ".form-product-container"
      ); // the main form
      const productContainer = document.querySelector(".product-container"); //the second container
      const ProductVendorName = document
        .querySelector(".vendor-name")
        .textContent.trim();
  
      console.log(vendorArray);
      console.log(ProductVendorName);
      if (vendorArray.length >= 4) {
        if (vendorArray.includes(ProductVendorName)) {
          console.log(true);
          formProductContainer.style.display = "block";
          productContainer.style.display = "none";
        } else {
          console.log(false);
          formProductContainer.style.display = "none";
          productContainer.style.display = "block";
          alertMessage(
            "You’ve hit the vendor limit for this order!",
            "You can still shop freely and add as many products as you want from them!"
          ); // alert message
        }
      }
    }
  }
  // Start vendor limitation function in home page
  function checkArrayFun() {
    const productsHomePage = document.querySelectorAll("div.t4s-product-wrapper");
    productsHomePage.forEach((element) => {
      const clickedElement = element
        .querySelector(".vendor-name-home")
        .textContent.trim();
      const button = element.querySelector(".first-product-button");
      const secondButton = element.querySelector(".second-product-button");
      // Start To check if the button text is out of stock or not
      const outOfStockText = button
        .querySelector("span.t4s-text-pr")
        .textContent.trim();
      if (outOfStockText === "Out of stock") {
        button.removeAttribute("data-action-atc");
        // button.style.border="2px solid blue";
        return;
      }
      // End To check if the button text is out of stock or not
      if (vendorArray.includes(clickedElement)) {
        button.style.display = "block";
        secondButton.style.display = "none";
      } else {
        button.style.display = "none";
        secondButton.style.display = "block";
      }
    });
  }
  console.log(vendorArray);
  // End test function
  document.addEventListener("cart:updated", () => {
    handleMiniCart();
    if (vendorArray.length >= 4) {
      checkForInput();
      checkArrayFun();
    }
    if (window.location.pathname === CART_PAGE_PATH) {
      checkCartPriceLimit();
    }
     checkMiniCartPriceLimit();
  });
  
  document.addEventListener("DOMContentLoad", () => {
    handleMiniCart();
    if (vendorArray.length >= 4) {
      checkForInput();
      checkArrayFun();
    }
    if (window.location.pathname === CART_PAGE_PATH) {
      checkCartPriceLimit();
    }
  });
  // SweetAlert message function
  function alertMessage(message, text) {
    return Swal.fire({
      title: `<strong>${message}</strong>`, // Bold title using HTML
      html: `${text}`, // Normal description
      focusConfirm: false,
      confirmButtonText: "OK",
      customClass: {
        popup: "custom-popup", // Class for the entire pop-up
        confirmButton: "custom-ok-button", // Custom class for button alignment
        title: "custom-title-class", // Optional: Add class to the title container
        htmlContainer: "custom-text-class", // Optional: Add class to the description container
      },
    });
  }
  // End
  // Start cart price limitation

  function priceProgressBar({
    cartTotal, 
    progressBarElement,
    prgressBarTextElement,
  }) {
    try {
    const priceEquation = (cartTotal / MIN_PRICE_LIMIT) * 100;
    const reminder = MIN_PRICE_LIMIT - cartTotal;
    const reminderText = reminder.toFixed(3);
    let progressBar = document.querySelector(progressBarElement);
    let prgressBarText = document.querySelector(prgressBarTextElement);
      if(cartTotal <= MIN_PRICE_LIMIT) {
    progressBar.style.width = `${priceEquation}%`;
    prgressBarText.textContent = `Add JOD ${reminderText} to place your order!`;
      } else {
         progressBar.style.width = "100%";
          prgressBarText.textContent = "Good to go!";
    }
    }catch (error) {
    console.error('Add to cart failed:', error);
    }
    }
  function checkCartPriceLimit() {
    let priceElement = document.querySelector(".cart-total-price");
    if (!priceElement) return;
    let totalPrice = parseFloat(priceElement.textContent.trim());
    if (totalPrice < MIN_PRICE_LIMIT) {
      let mainButton = document.querySelectorAll("button.main-proceed-btn");
      let secondButton = document.querySelectorAll("div.second-proceed-btn");
      mainButton.forEach((button) => {
        button.classList.add("change-button");
      });
      secondButton.forEach((button) => {
        button.style.display = "block";
      });
    }
        priceProgressBar({
       cartTotal : totalPrice,
      progressBarElement : ".price-progress #main-price-progress",
      prgressBarTextElement : ".vendor-progress-container #main-price-rate"
      });
  }
  function checkMiniCartPriceLimit() {
    let miniPriceElement = document.querySelector(".t4s-cart__totalPrice");
    if (!miniPriceElement) return;
    let miniTotalPrice = parseFloat(miniPriceElement.textContent.trim());
    let mainButton = document.querySelector("button.main-t4s-btn__checkout");
    let secondButton = document.querySelector("div.second-t4s-btn__checkout");
         priceProgressBar({
       cartTotal : miniTotalPrice,
      progressBarElement : ".price-progress #price-progress",
      prgressBarTextElement : ".vendor-progress-container #price-rate"
      });
    if (miniTotalPrice < MIN_PRICE_LIMIT) {
      mainButton.style.display = "none";
      secondButton.style.display = "flex";
    } else {
      mainButton.style.display = "block";
      secondButton.style.display = "none";
    }
    console.log(miniTotalPrice);
  }
  if (window.location.pathname === CART_PAGE_PATH) {
    checkCartPriceLimit();
  }

  // End